module.exports = __webpack_public_path__ + "img/realme-wh.1d7cca0a.svg";